export default __webpack_public_path__ + "static/media/test-drive-banner-lv.57a10673.jpg";